module.exports = __webpack_public_path__ + "static/media/football.74ca11a2.jpg";